export const ENDPOINT_DEPARTMANT_ACTIVITY_FIND_ALL = '/api/department-activity/list';
export const ENDPOINT_DEPARTMANT_ACTIVITY_CREATE_ONE = '/api/department-activity/create';
export const ENDPOINT_DEPARTMANT_ACTIVITY_UPDATE_ONE = '/api/department-activity/update';
export const ENDPOINT_DEPARTMANT_ACTIVITY_DELETE_ONE = '/api/department-activity/delete';
